import { call, put, takeLatest } from 'redux-saga/effects';
import {
  submitOwnerDetailsFailure,
  submitOwnerDetailsRequest,
  submitOwnerDetailsSuccess,
} from 'redux/slice/agency-onbording/OwnerDetails.slice';
import { agencyOnboarding } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

const submitAgencyDetailsApi = (agencyData: any) => {
  return HTTPClient.PostRequest(
    agencyOnboarding.AGENCY_OWNER_DETAILS,
    agencyData
  );
};

function* submitAgencyDetailsSaga(action: any): any {
  try {
    const response = yield call(submitAgencyDetailsApi, action.payload);
    yield put(submitOwnerDetailsSuccess()); // On success, dispatch success action
  } catch (error: any) {
    yield put(submitOwnerDetailsFailure(error.message)); // On failure, dispatch failure action
  }
}

export function* watchAgencyOnboardingSaga() {
  yield takeLatest(submitOwnerDetailsRequest.type, submitAgencyDetailsSaga);
}
